import { inject, Injectable } from '@angular/core';

import { GroupStoreActions, GroupStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { environment } from '@rocksoft/environment';
import { EnvironmentFeatures } from '@rocksoft/shared';
import { AuthorizationService, Permissions } from '@rocksoft/shared/authorization';
import { combineLatest, Observable, of } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GroupResolver {
  private readonly store = inject(Store);
  private readonly authorizationService = inject(AuthorizationService);

  private readonly features: EnvironmentFeatures = environment.features;

  resolve(): Observable<boolean> {
    if (!this.features.security?.enabled) {
      return of(true);
    }

    const groupsLoaded$ = this.store.select(GroupStoreSelectors.selectGroupsLoaded);
    const authorized$ = this.authorizationService.getIsAuthorized$(Permissions.SecurityListGroups);

    return combineLatest([groupsLoaded$, authorized$]).pipe(
      map(([loaded, authorized]) => !loaded && authorized),
      tap((shouldRequest) => {
        if (shouldRequest) {
          this.store.dispatch(GroupStoreActions.GroupResolverActions.groupsRequested());
        }
      }),
      first()
    );
  }
}
